import React from "react";
import { List, Datagrid, DeleteWithConfirmButton, TextField, ShowButton, EditButton } from "react-admin";
import { EmptyList } from "../../../common/components";

const CompetitionList = () => {
  return (
    <List
      hasCreate
      exporter={false}
    >
      <Datagrid
        bulkActionButtons={false}
        empty={<EmptyList />}
      >
        <TextField
          label="№"
          source="id"
          sortable={false}
        />
        <TextField
          label="Име"
          source="title"
          sortable={false}
        />

        <ShowButton />
        <EditButton />
        <DeleteWithConfirmButton />
      </Datagrid>
    </List>
  );
};

export default CompetitionList;
